export default "__VITE_ASSET__Bt6Mi76O__"